<template>
    <ChannelsGeneral title="Voice">
        <template #content>
            <p>
                Voice is still the most personal way to connect — and Yabbr takes it further. From inbound call routing to <b>outbound robocalling, predictive diallers, live transcription, and IVR menus</b>, Voice on Yabbr is built for scale. You get all of this, without ever having to pickup a phone. <br><br>
                Whether you need enterprise-grade call centres or simple payment reminders, Voice adapts to the way your business works.
            </p>
        </template>
        <template #img>
            <v-img
            src="../assets/img/voice.png"
            alt="Voice Calling"
            max-width="350px"
            />
        </template>
    </ChannelsGeneral>
</template>

<script>
import ChannelsGeneral from './ChannelsGeneral.vue'

export default {
    name: 'ChannelsVoice',
    components: {
    ChannelsGeneral
    }
}
</script>

<style lang="scss">
</style>